import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

const DELETE_DIET_MUTATION = gql`
  mutation deleteDiet($id: ID!) {
    deleteDiet(id: $id) {
      results {
        id
        name
        isCurationEnabled
        level
        idPath
        namePath
        type
        children {
          id
          name
          isCurationEnabled
          level
          idPath
          namePath
          type
          parentId
        }
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${EVENT_FRAGMENT}
`

export default DELETE_DIET_MUTATION
